module.exports = __webpack_public_path__ + "img/web.079bd7b2.svg";